import type { AppEntryContext } from '@core/entities/AppEntryContext';
import { AppEntryGatewayError, type AppEntryContextGateway } from '@core/ports/AppEntryContextGateway';
import { AuthenticatedBffTransport } from '@infrastructure/http/AuthenticatedBffTransport';
import { BffTransportError } from '@infrastructure/http/BffTransportError';

export class BffAppEntryContextHttpGateway implements AppEntryContextGateway {
  public constructor(private readonly transport = new AuthenticatedBffTransport()) {}

  public async getContext(): Promise<AppEntryContext> {
    let response: Response;

    try {
      response = await this.transport.fetch('/api/app-entry/context', {
        headers: {
          Accept: 'application/json',
        },
      });
    } catch (error) {
      if (error instanceof BffTransportError && error.code === 'offline') {
        throw new AppEntryGatewayError('offline', 'Your internet connection appears to be unavailable. Reconnect to the internet, then start again from the NHS App if you still need help.');
      }

      throw new AppEntryGatewayError('request-failed', 'Unable to reach Intelligent Navigator right now. Check your connection and try again.');
    }

    if (response.status === 401) {
      throw new AppEntryGatewayError('session-required', 'Start this journey from the NHS App to continue.');
    }

    if (!response.ok) {
      throw new AppEntryGatewayError('request-failed', 'Unable to load the information needed to start this journey.');
    }

    return (await response.json()) as AppEntryContext;
  }
}